import { useMutation } from '@apollo/client'
import { USER_DEVICE_INFO } from '~/graphqls/gqls'
import {
  FromEnum,
  userDeviceInfo,
  userDeviceInfoVariables,
} from '~/graphqls/types'
import { randomRange } from '~/utils'
import { UAParser } from 'ua-parser-js'
import Cookies from 'js-cookie'
import { USER_DEVICE_KEY } from '~/configs'

export const useDeviceInfo = () => {
  const [userDeviceAction] = useMutation<
    userDeviceInfo,
    userDeviceInfoVariables
  >(USER_DEVICE_INFO)
  const parser = new UAParser()
  const { browser } = parser.getResult()

  const handleSendDeviceInfo = async () => {
    const cid = randomRange(20, 20)
    try {
      await userDeviceAction({
        variables: {
          cid: cid,
          input: {
            deviceId: cid,
            from: FromEnum.WEB,
            userAgent: `${browser.name} / ${browser.version}`,
          },
        },
      })
      Cookies.set(USER_DEVICE_KEY, 'true', {
        expires: 1,
      })
    } catch (error) {}
  }
  return {
    handleSendDeviceInfo,
  }
}
